var map = {
	"./TXT-SOCIAL-ANGELLIST.png": "7ffb",
	"./TXT-SOCIAL-AUDIOMACK.png": "050c",
	"./TXT-SOCIAL-BANDCAMP.png": "17b3",
	"./TXT-SOCIAL-BEHANCE.png": "f7de",
	"./TXT-SOCIAL-BITBUCKET.png": "a28c",
	"./TXT-SOCIAL-BLOG.png": "af0a",
	"./TXT-SOCIAL-CLASSMATES.png": "5b1d",
	"./TXT-SOCIAL-CODEPEN.png": "c12a",
	"./TXT-SOCIAL-DISCORD.png": "348c",
	"./TXT-SOCIAL-DRIBBBLE.png": "41e9",
	"./TXT-SOCIAL-DROOBLE.png": "8bbc",
	"./TXT-SOCIAL-FACEBOOK.png": "ec3b",
	"./TXT-SOCIAL-FUNDLY.png": "dee4",
	"./TXT-SOCIAL-GITHUB.png": "8397",
	"./TXT-SOCIAL-GOFUNDME.png": "31d3",
	"./TXT-SOCIAL-GOOGLEPLUS.png": "e22a",
	"./TXT-SOCIAL-HOUZZ.png": "de32",
	"./TXT-SOCIAL-INDIEGOGO.png": "ac76",
	"./TXT-SOCIAL-INSTAGRAM.png": "934d",
	"./TXT-SOCIAL-ITUNES.png": "d886",
	"./TXT-SOCIAL-KICKSTARTER.png": "07d3",
	"./TXT-SOCIAL-LASTFM.png": "f728",
	"./TXT-SOCIAL-LINKEDIN.png": "2c86",
	"./TXT-SOCIAL-MATCH.png": "52a6",
	"./TXT-SOCIAL-MEDIUM.png": "3470",
	"./TXT-SOCIAL-MEETUP.png": "02d8",
	"./TXT-SOCIAL-PINTEREST.png": "deb8",
	"./TXT-SOCIAL-REDDIT.png": "5632",
	"./TXT-SOCIAL-SKYPE.png": "ff36",
	"./TXT-SOCIAL-SLACK.png": "20d0",
	"./TXT-SOCIAL-SOUNDCLOUD.png": "6e2f",
	"./TXT-SOCIAL-SPOTIFY.png": "2c13",
	"./TXT-SOCIAL-STACKOVERFLOW.png": "3b1a",
	"./TXT-SOCIAL-STEAM.png": "1100",
	"./TXT-SOCIAL-SURVEYMONKEY.png": "6361",
	"./TXT-SOCIAL-TINDER.png": "99be",
	"./TXT-SOCIAL-TRELLO.png": "932b",
	"./TXT-SOCIAL-TUMBLR.png": "0fde",
	"./TXT-SOCIAL-TWITCH.png": "9d2e",
	"./TXT-SOCIAL-TWITTER.png": "be3f",
	"./TXT-SOCIAL-UPWORK.png": "b2b7",
	"./TXT-SOCIAL-VIMEO.png": "3417",
	"./TXT-SOCIAL-VSCO.png": "48a1",
	"./TXT-SOCIAL-WORDPRESS.png": "e0ac",
	"./TXT-SOCIAL-YOUCARING.png": "4257",
	"./TXT-SOCIAL-YOUTUBE.png": "c08d",
	"./TXT-SOCIAL-YOUTUBEPLAY.png": "d712"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4980";